// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getDatabase, ref, set, get } from 'firebase/database';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBRUGzL3Aqs4AhEgyu_WbTXkgJoVSXs90M",
  authDomain: "bonferweb.firebaseapp.com",
  projectId: "bonferweb",
  storageBucket: "bonferweb.appspot.com",
  messagingSenderId: "1036847360207",
  appId: "1:1036847360207:web:30fc25307aeb7909f3afba",
  measurementId: "G-342M2P0MCV"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const database = getDatabase(app);

export { database, ref, set, get };